// extracted by mini-css-extract-plugin
export var container = "Artworks-module--container--56629";
export var layout = "Artworks-module--layout--4125f";
export var content = "Artworks-module--content--d860b";
export var slider = "Artworks-module--slider--86ce0";
export var controls = "Artworks-module--controls--c5160";